export default __webpack_public_path__ + "static/media/character2.f32a128a.png";